import { useQuery } from '@apollo/client';
import { formatFullName } from '@dokucoach/common-types';
import { useContextAuthManager } from 'components/AuthManager';
import {
  LoginIcon,
  LoginIconWrapper,
  MessagesBadge,
  UnreadMessages,
} from 'components/Layout/components/LoginInfo/index.styled';
import { useContextSnackbar } from 'components/Snackbar/context';
import React, { useEffect, useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { GET_UNREAD_MESSAGES } from 'services/roster-configuration';
import HttpClient from 'utils/httpClient';

const LoginInfo = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const { showApiError } = useContextSnackbar();
  const { user, timeosConfig } = useContextAuthManager();
  const [initials, setInitials] = useState<string>('');
  const [name, setName] = useState<string>('');
  const [messages, setMessages] = useState<number>();

  const {
    data: messagesData,
    error: messagesError,
    refetch: refetchMessages,
  } = useQuery(GET_UNREAD_MESSAGES, {
    variables: {
      userId: `${timeosConfig?.timeosUser?.id}`,
    },
    // skip if we do not have a timeos user or customerId
    skip: !timeosConfig?.timeosUser?.id || !timeosConfig?.timeosCustomerId,
  });

  useEffect(() => {
    if (messagesError) {
      showApiError(messagesError);
      return;
    }
    if (messagesData) {
      setMessages(messagesData.getUnreadMessages);
    }
  }, [messagesData, messagesError]);

  useEffect(() => {
    refetchMessages();
  }, [location.pathname]);

  useEffect(() => {
    if (!user?.name) return;
    setName(formatFullName(user.name));
    setInitials(`${user.name.firstFull.charAt(0)}${user.name.last.charAt(0)}`);
  }, [user]);

  return (
    <LoginIconWrapper>
      <LoginIcon data-toggle="tab" data-target="#logged-in" data-test="loginInfo" role="tab">
        {/* display user initials */}
        <OverlayTrigger placement="right" overlay={<Tooltip id={'logged-in'}>{name}</Tooltip>}>
          <span>{initials}</span>
        </OverlayTrigger>

        {/* show the following only if the user has unread messages */}
        {messages && messages > 0 && (
          <OverlayTrigger
            placement="right"
            overlay={
              <Tooltip id={'unread-timeos-messages'}>
                {messages}&nbsp;{t('unread_messages')}
              </Tooltip>
            }
          >
            <MessagesBadge
              onClick={async () => {
                const res = await HttpClient.get(`user/timeosLoginUrl?redirectPageId=messages`);
                const redirectUrl = await res.text();
                window.open(redirectUrl);
              }}
            >
              <UnreadMessages>{messages}</UnreadMessages>
            </MessagesBadge>
          </OverlayTrigger>
        )}
      </LoginIcon>
    </LoginIconWrapper>
  );
};

export default LoginInfo;
